import { render, staticRenderFns } from "./DepartmentCharge.vue?vue&type=template&id=4b7a9245&scoped=true&"
import script from "./DepartmentCharge.vue?vue&type=script&lang=js&"
export * from "./DepartmentCharge.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentCharge.vue?vue&type=style&index=0&id=4b7a9245&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7a9245",
  null
  
)

export default component.exports